import React, { useRef, useState, useEffect } from 'react';
import WistiaCta from 'components/Core/WistiaVideo/components/WistiaCta';
import WistiaContext from 'utils/WistiaContext';
import useBreakpointView from 'utils/useBreakpointView';
import useThumbnail from './utils/useThumbnail';
import getWistiaComponent from './utils/getWistiaComponent';
import usePlayPauseActions from './utils/usePlayPauseActions';
import { WistiaWrapper } from './styles';
import './wistia-popup.less';
import getVideoRatio from './utils/getVideoRatio';
import getVideoType from './utils/getVideoType';
import useScript from './utils/useScript';
import YouTubeVideo from './YouTubeVideo';

const WistiaVideo = (props) => {
  const {
    autoPlay,
    ctaBody,
    ctaTitle,
    customCta,
    dataPosition,
    dataTestId,
    label,
    overlay,
    playAudioOnly,
    popoverCta,
    size,
    thumbnail,
    url,
    wrapperClass,
    wrapperStyles,
    thumbnailLoading,
  } = props;

  useScript();

  const wrapperRef = useRef();
  const [isPlaying, setIsPlaying] = useState(!!autoPlay);
  const [isModalOpen, toggleIsModalOpen] = useState(false);
  const [videoPlayer, setVideoPlayer] = useState();
  const isMobile = useBreakpointView(['xs', 'sm']);
  const ratio = getVideoRatio(url);
  const renderThumbnail = useThumbnail(thumbnail, url);
  const videoId = url?.substring(url.length - 10);
  const includesCta = popoverCta && ctaBody && ctaTitle;
  const type = getVideoType(props);

  const parentSlide = wrapperRef?.current?.closest('.slick-slide');
  const isActiveSlide = wrapperRef?.current?.closest('.slick-active');

  let isYouTube = false;
  try {
    const parsedUrl = new URL(url);
    const { hostname } = parsedUrl;
    isYouTube = hostname === 'www.youtube.com' || hostname.endsWith('.youtube.com');
  } catch (e) {
    console.error('Invalid URL:', url);
  }

  if (!isActiveSlide && parentSlide) {
    videoPlayer?.pause();
  }

  const Component = getWistiaComponent({ isMobile, ...props });

  usePlayPauseActions(
    dataPosition,
    isModalOpen,
    isPlaying,
    setIsPlaying,
    setVideoPlayer,
    type,
    videoId,
    videoPlayer,
  );

  useEffect(() => {
    setIsPlaying(!!autoPlay);
  }, [autoPlay]);

  useEffect(() => {
    if (playAudioOnly && isPlaying) {
      setTimeout(() => {
        document.body.style.overflow = null;
      }, 500);
    }
  }, [isPlaying]);

  if (isYouTube) {
    <YouTubeVideo url={url} />;
  }

  return (
    <WistiaContext.Provider
      value={{
        ...props,
        autoPlay,
        customCta,
        includesCta: !!includesCta,
        isActiveSlide,
        isModalOpen,
        isPlaying,
        overlay,
        parentSlide,
        popoverContent: <WistiaCta />,
        ratio,
        setIsPlaying,
        toggleIsModalOpen,
        thumbnail: renderThumbnail,
        url,
        videoId,
        videoPlayer,
        thumbnailLoading,
      }}
    >
      <WistiaWrapper
        className={`wistia-video--wrapper ${wrapperClass}`}
        data-testid={dataTestId}
        $isPlaying={isPlaying}
        $label={label}
        ref={wrapperRef}
        $size={size}
        style={wrapperStyles}
      >
        <Component />
      </WistiaWrapper>
    </WistiaContext.Provider>
  );
};

WistiaVideo.defaultProps = {
  inline: false,
};

export default WistiaVideo;
